import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

import { OrderStatusControl } from './OrderStatusControl';
import type { Order } from './types';

interface OrderHeaderRowProps {
  order: Pick<Order, 'id' | 'reference_number' | 'order_status'>;
  leading: ReactNode;
  headingAs: 'h1' | 'h2';
  className?: string;
}

export function OrderHeaderRow({ order, leading, headingAs: Heading, className }: OrderHeaderRowProps) {
  return (
    <div className={cn('flex w-full items-center justify-between', className)}>
      <div className="flex items-center gap-3">
        {leading}
        <Heading className="font-inter text-lg font-semibold text-off-black">{order.reference_number}</Heading>
      </div>
      <OrderStatusControl orderId={order.id} status={order.order_status} />
    </div>
  );
}
